const fadesettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: false,
  fade: true,
  swipeToSlide: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 500,
  pauseOnHover: false,
  centerMode: false,
  className: "jslide",
};

export default fadesettings;
